import { format, toZonedTime } from 'date-fns-tz';
import { ActorRole, AssessmentExpiryOption } from 'generated/graphql';
import { actorRoleLabels } from 'helpers/actorRoles';

export const getYesOrNo = (value: boolean): string => (value ? 'Yes' : 'No');

export const parseActorRolesToString = (rolesArray: ActorRole[]): string =>
  rolesArray.length
    ? rolesArray.map(role => actorRoleLabels[role]).join(', ')
    : 'N/A';

export const getStageDate = (dateString: string): string => {
  const date = new Date(dateString);
  const utcDate = toZonedTime(date, 'UTC');
  return `${format(utcDate, 'dd/MM/yyyy HH:mm')} UTC`;
};

export const getExpiryOptionLabel = (
  expiryOption?: AssessmentExpiryOption | null
): string => {
  if (!expiryOption) {
    return 'No';
  }

  const duration = expiryOption.duration;
  const unit = duration === 1 ? 'day' : 'days';
  return `Yes, ${duration} ${unit}`;
};
